import { Component, Prop, h, Host, ComponentInterface } from '@stencil/core';

@Component({
  tag: 'rt-table',
  shadow: true,
  styleUrl: 'table.scss',
})
export class TableComponent implements ComponentInterface {
  @Prop() columns;
  @Prop() rows;
  @Prop() columnLabelTitle: string;
  @Prop() columnValueTitle: string;

  render() {
    return (
      <Host>
        <div class={'table-container'}>
          <table>
            <tr>
              <th>
                <span>{this.columnLabelTitle}</span>
                <span>{this.columnValueTitle}</span>
              </th>
              {this.columns.map((label) => (
                <th>{label}</th>
              ))}
            </tr>
            {this.rows.map((row) => (
              <tr>
                <td>{row.render}</td>
                {row.labels.map((label) => (
                  <td>
                    <span class="col-label">{label.label}</span>
                    <span>{label.value}</span>
                  </td>
                ))}
              </tr>
            ))}
          </table>
        </div>
      </Host>
    );
  }
}
